import React from 'react';

import { useRecoilState } from 'recoil';
import { subAtom } from 'core/config/atoms';

import moment from "moment";
import QRCode from "react-qr-code";

export const PrintBill = React.forwardRef((props, ref) => {

    const [sub] = useRecoilState(subAtom);

    const paymentMode = (mode) => {
        switch (mode) {
            case "cash":
                return "Cash";
            case "upi":
                return "UPI";
            case "card":
                return "Card Payment";
            case "bank":
                return "Bank Payment";
            case "nc":
                return "Complimentary";
            default:
                return "NA";
        }
    }

    const getTotal = (ordItems) => {
        let total = 0;
        ordItems.forEach((a) => {
            total = total + (a.price * a.qty);
        });
        return total;
    }

    const getDiscount = (ord) => {
        let dis = 0;
        if (parseFloat(ord.discount) !== 0) {
            if (ord.dmode === "A") {
                dis = parseFloat(ord.discount)
            } else {
                dis = getTotal() * (parseFloat(ord.discount) / 100);
            }
        }
        return dis;
    }

    const getRoundOff = (ordTemp) => {
        const finalTotal = (ordTemp.total - ordTemp.discount) + ordTemp.tax + ordTemp.scharge;
        const roundedTotal = Math.round(finalTotal);
        const roundOffValue = (roundedTotal - finalTotal).toFixed(2);
        if (roundOffValue === "0.00") {
            return roundOffValue;
        }
        return roundOffValue > 0 ? `+${roundOffValue}` : roundOffValue;
    }

    const isCust = () => {
        if (props.payload.data.customer) {
            return true;
        }
        return false;
    }

    return (
        <div className={`mx-auto text-sm p-2 ${props.isPrint ? '' : 'hidden'}`} ref={ref}>
            {
                props.isPrint && <div className="space-y-1 bg-white px-1 py-2">
                    <div className="mt-2">
                        <h2 className="text-center text-2xl font-bold uppercase">{props.payload.outlet.tradNme}</h2>
                        <p className="text-center text-base font-medium">{props.payload.outlet.addresses[0].street_1}, {props.payload.outlet.addresses[0].street_2}, {props.payload.outlet.addresses[0].city} - {props.payload.outlet.addresses[0].postal_code}</p>
                        <p className="text-center text-base font-medium">{props.payload.outlet.phone}</p>
                    </div>
                    <div className="my-2 h-[1px] bg-black" />
                    <h2 className="text-center text-2xl font-bold uppercase">Tax Invoice</h2>
                    <div className="my-2 h-[1px] bg-black" />
                    <p className="text-lg font-medium">Buyer: <span className='font-normal'>{paymentMode(props.payload.data.pmode)}</span></p>
                    <p className="text-lg font-medium">Invoice No.: <span className='font-normal'>{props.payload.data.invid}</span></p>
                    <p className="text-lg font-medium">Date: <span className='font-normal'>{moment(props.payload.data.createdAt).toISOString()}</span></p>
                    <p className="text-lg font-medium">Table: <span className='font-normal'>{props.payload.unit}</span></p>
                    <p className="text-lg font-medium">Provider: <span className='font-normal'>{props.payload.provider}</span></p>
                    <div className="my-2 h-[1px] bg-black" />
                    {
                        isCust() && <>
                            <p className="text-xl font-medium">Customer</p>
                            <p className="text-lg font-medium">Name: <span className='font-normal'>{props.payload.data.customer.name}</span></p>
                            <p className="text-lg font-medium">Email: <span className='font-normal'>{props.payload.data.customer.email}</span></p>
                            <p className="text-lg font-medium">Phone: <span className='font-normal'>{props.payload.data.customer.phone}</span></p>
                            <div className="my-2 h-[1px] bg-black" />
                        </>
                    }
                    <div>
                        <p className="text-lg font-medium">Item Description</p>
                        <div className='flex items-center justify-between'>
                            <p className="text-lg font-medium">QTY</p>
                            <p className="text-lg font-medium">Rate</p>
                            <p className="text-lg font-medium">Amount</p>
                        </div>
                    </div>
                    <div className="my-2 h-[1px] bg-black" />
                    {
                        props.payload.data.items.map((item, index) => (
                            <div key={index} className='my-1'>
                                <p className="text-lg">{item.name}</p>
                                <div className='flex items-center justify-between'>
                                    <p className="text-lg">{item.qty}</p>
                                    <p className="text-lg">₹ {item.price.toFixed(2)}</p>
                                    <p className="text-lg">₹ {(item.price * item.qty).toFixed(2)}</p>
                                </div>
                                <p className="text-lg"></p>
                                <p className="text-lg"></p>
                            </div>
                        ))
                    }
                    <div className="my-2 h-[1px] bg-black" />
                    <div className='flex items-center justify-between'>
                        <p className="text-lg">Sub Total</p>
                        <p className="text-lg">₹ {getTotal(props.payload.data.items).toFixed(2)}</p>
                    </div>
                    <div className='flex items-center justify-between'>
                        <p className="text-lg">@ Discount ({props.payload.data.dmode === "A" ? "₹" : "%"})</p>
                        <p className="text-lg">₹ {getDiscount(props.payload.data)}</p>
                    </div>
                    {
                        sub.features.isTax && <div className='flex items-center justify-between'>
                            <p className="text-lg">Tax (₹)</p>
                            <p className="text-lg">₹ {props.payload.data.tax.toFixed(2)}</p>
                        </div>
                    }
                    {
                        props.payload.data.scharge !== 0 && <div className='flex items-center justify-between'>
                            <p className="text-lg">Service Charges</p>
                            <p className="text-lg">₹ {props.payload.data.scharge.toFixed(2)}</p>
                        </div>
                    }
                    <div className='flex items-center justify-between'>
                        <p className="text-lg">Round Off</p>
                        <p className="text-lg">₹ {getRoundOff(props.payload.data)}</p>
                    </div>
                    <div className='flex items-center justify-between'>
                        <p className="text-xl font-medium">Net Payable</p>
                        <p className="text-xl font-medium">₹ {props.payload.data.grand.toFixed(2)}</p>
                    </div>
                    <div className="my-2 h-[1px] bg-black" />
                    <div className="my-2 h-[1px] bg-black" />
                    <p className="text-center text-lg font-medium mt-2">
                        Thank you for visiting us!!!
                    </p>
                    {
                        props.payload.outlet.upi && <div className='mt-4 flex flex-col items-center justify-center'>
                            <p className='text-sm font-semibold mb-2'>Scan to Pay</p>
                            <QRCode size={128} style={{ height: "auto", maxWidth: "100%", width: "100px" }} value={`upi://pay?pa=${props.payload.outlet.upi}&pn=${props.payload.outlet.tradNme}&am=${props.payload.data.grand}&cu=INR`} viewBox={`0 0 128 128`} />
                            <p className='text-xs font-medium mt-1'>{props.payload.outlet.upi}</p>
                        </div>
                    }
                </div>
            }
        </div>
    )
});
